import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import clsxm from '../utils/clsxm';

const ChatButton = ({ onClick, isGamePage, className }) => {
  // if (!isGamePage) return null;

  return (
    <button
      onClick={onClick}
      className={clsxm("fixed bottom-4 right-4 z-30 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white p-3 rounded-full shadow-lg transition-all duration-200 transform hover:scale-110 lg:hidden", className)}
    >
      <ChatBubbleLeftRightIcon className="h-6 w-6" />
    </button>
  );
};

export default ChatButton;
